import { useDataSource } from '@/src/renderer/lib/dataSource'
import type { Goal, LifeSpace } from '@/src/renderer/lib/db/models'

/**
 * Reactive list of goals for a life space, newest-first.
 *
 * Returns `undefined` while the first read is still pending, so callers can
 * render a loading state. Soft-deleted goals are excluded.
 */
export function useGoals(lifeSpace: LifeSpace): Goal[] | undefined {
  return useDataSource().useGoals(lifeSpace)
}
